import { render } from "./LKFPagination.vue?vue&type=template&id=4d7d95c8&ts=true"
import script from "./LKFPagination.vue?vue&type=script&lang=ts"
export * from "./LKFPagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__